import type { SummaryCreditRatingSlice } from '../api/chartDataTypes';

export type SummaryCreditRatingSummary = {
    /** Plain-text version — used by the NVDA live region. */
    text: string;
    /** Same content with the percentage wrapped in <strong> for the visual
     *  banner. HTML-escapes the label + display tokens so values containing
     *  characters like `<` render literally instead of being parsed as a tag. */
    html: string;
};

function escapeHtml(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function stripPercent(display: string): string {
    return display.replace(/\s*%\s*$/, '');
}

/**
 * "Investment Grade: 59.6 percent."
 *
 * Mirrors assetAllocationFormat — payloads share an identical slice shape but
 * the format util is kept separate per chart type to match the project's
 * one-utility-per-chart-type convention.
 */
export function buildSummaryCreditRatingSummarySentence(
    slice: SummaryCreditRatingSlice,
): SummaryCreditRatingSummary {
    return {
        text: `${slice.label}: ${stripPercent(slice.display)} percent.`,
        html: `${escapeHtml(slice.label)}: <strong>${escapeHtml(slice.display)}</strong>.`,
    };
}
